import LoginSecondaryHeaderComponent from '../components/LoginSecondaryHeaderComponent.vue';
import SecondaryHeaderComponent from '../components/SecondaryHeaderComponent.vue';
import MobileHeaderComponent from '../components/MobileHeaderComponent.vue';
import CreditProgress from '../components/CreditProgress.vue';
import Announcement from '../components/Announcement.vue';
import VerificationStatus from '../components/VerificationStatus.vue';
import MyCourses from '../components/MyCourses.vue';
import SelectedCourses from '../components/SelectedCourses.vue';
import FooterComponent from '../components/FooterComponent.vue';
import CurrentGPA from '../components/CurrentGPA.vue';
import ErrorComponent from '../components/ErrorComponent.vue';
import CongratsYellow from '../components/CongratsYellow.vue';
import LoginSteps from '../components/LoginSteps.vue';
import Orientation from '../components/Orientation.vue';
import Registerv2 from '../components/Registerv2.vue';
import CollegeCourses from '../components/CollegeCourses.vue';
import UpgradeCourseModal from '../components/UpgradeCourseModal.vue';
import CreateLearnerComponent from '../components/CreateLearnerComponent.vue';
import CreateLearnerComponentv2 from '../components/CreateLearnerComponentv2.vue';
import WelcomeLogin from '../components/WelcomeLoginComponent.vue';
import Video from '../components/Video.vue';
import MyProgress from '../components/pathways/MyProgress.vue';
import CourseCheckout from '../components/CourseCheckout.vue';
import CheckoutSelectedCourse from '../components/CheckoutSelectedCourse.vue';
import CreditRequestFrom from '../components/CreditRequestFrom.vue';
import SvgDivider from '../components/SvgDivider.vue';
import ProfileCompletion from '../components/ProfileCompletion.vue';
import AppNoticeBanner from '../components/AppNoticeBanner.vue';
import SuccessCoach from '../components/SuccessCoach.vue';
import LoadingSpinner from '../components/ui/LoadingSpinner.vue';
import ParentConsentModal from '../components/ParentConsentModal.vue';
// PaypalCheckout is migrated to @paypal/paypal-js and registered locally in CheckoutSelectedCourse.vue
// import PaypalCheckout from '../components/PaypalCheckout.vue';

// Import missing components or comment them out if they don't exist
// import WelcomeYellow from '../components/WelcomeYellow.vue';
// import UserInfo from '../components/UserInfo.vue';
// import SignUp from '../components/SignUp.vue';

const globalComponents = [
  { name: 'login-secondary-header-component', component: LoginSecondaryHeaderComponent },
  { name: 'secondary-header-component', component: SecondaryHeaderComponent },
  { name: 'mobile-header-component', component: MobileHeaderComponent },
  { name: 'credit-progress', component: CreditProgress },
  { name: 'create-learner-component', component: CreateLearnerComponent },
  { name: 'create-learner-component-v2', component: CreateLearnerComponentv2 },
  { name: 'welcome-login', component: WelcomeLogin },
  { name: 'announcement', component: Announcement },
  { name: 'verification-status', component: VerificationStatus },
  { name: 'my-courses', component: MyCourses },
  { name: 'selected-courses', component: SelectedCourses },
  { name: 'footer-component', component: FooterComponent },
  { name: 'current-GPA', component: CurrentGPA },
  { name: 'error-component', component: ErrorComponent },
  { name: 'congrats-yellow', component: CongratsYellow },
  { name: 'login-steps', component: LoginSteps },
  { name: 'Orientation', component: Orientation },
  { name: 'register-v2', component: Registerv2 },
  { name: 'CollegeCourses', component: CollegeCourses },
  { name: 'UpgradeCourseModal', component: UpgradeCourseModal },
  { name: 'video-component', component: Video },
  { name: 'my-progress', component: MyProgress },
  { name: 'checkout-selected-course', component: CheckoutSelectedCourse },
  { name: 'courses-checkout', component: CourseCheckout },
  { name: 'credit-request-from', component: CreditRequestFrom },
  { name: 'svg-divider', component: SvgDivider },
  { name: 'profile-completion', component: ProfileCompletion },
  { name: 'app-notice-banner', component: AppNoticeBanner },
  { name: 'success-coach', component: SuccessCoach },
  { name: 'loading-spinner', component: LoadingSpinner },
  { name: 'parent-consent-modal', component: ParentConsentModal }
  // { name: 'paypal-checkout', component: PaypalCheckout }
];

export { globalComponents };
